import { Controller } from '@hotwired/stimulus'

// Bulk cancel jobs modal. Attached to the same element as the `modal`
// controller. Validates the reason field, toggles the rebook fields and
// cancels each selected job sequentially via fetch.
export default class extends Controller {
  static targets = [
    'form',
    'reason',
    'jobIds',
    'satisfaction',
    'rebookCheckbox',
    'rebookFields',
    'cancelBtn',
    'rebookBtn',
    'returnPath'
  ]

  connect() {
    this.validate()
  }

  validate() {
    const hasReason = this.reasonTarget.value.trim().length > 0
    this.cancelBtnTarget.disabled = !hasReason
    this.rebookBtnTarget.disabled = !hasReason
  }

  toggleRebook() {
    const rebook = this.rebookCheckboxTarget.checked
    this.rebookFieldsTarget.classList.toggle('hidden', !rebook)
    this.cancelBtnTarget.style.display = rebook ? 'none' : ''
    this.rebookBtnTarget.style.display = rebook ? '' : 'none'
  }

  async submit(event) {
    event.preventDefault()
    const ids = (this.jobIdsTarget.value || '').split(',').filter(Boolean)
    if (ids.length === 0) {
      this.modalController.close()
      return
    }

    const token = this.csrfToken()
    const body = {
      authenticity_token: token,
      reason: this.reasonTarget.value,
      satisfaction_level: this.satisfactionTarget.value,
      rebooked: this.rebookCheckboxTarget.checked ? '1' : '0',
      rebook_date: this.element.querySelector('#bulk_rebook_date')?.value || '',
      rebook_work_list_category_id: this.element.querySelector('#bulk_rebook_work_list_category_id')?.value || '',
      return_path: this.returnPathTarget.value
    }

    this.cancelBtnTarget.disabled = true
    this.rebookBtnTarget.disabled = true

    let completed = 0
    let failed = 0

    for (const id of ids) {
      try {
        const response = await fetch(`/jobs/${id}/cancel`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-CSRF-Token': token },
          body: new URLSearchParams(body)
        })
        if (response.ok) {
          completed += 1
        } else {
          failed += 1
        }
      } catch (error) {
        failed += 1
      }
    }

    this.modalController.close()
    if (failed > 0) alert(`Canceled ${completed} jobs. ${failed} failed.`)
    window.location.reload()
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
  }

  get modalController() {
    return this.application.getControllerForElementAndIdentifier(this.element, 'modal')
  }
}
